export default __webpack_public_path__ + "static/proxima-nova-500-caabbedca99a82324ad7957707424b51.woff";